module.exports = __webpack_public_path__ + "static/media/mcsedmikraska.aaf7fa3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/sponsors/mcsedmikraska.png
// module id = 504
// module chunks = 0